const Payload = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Payload')
export default {
  component: Payload,
  meta: {
    breadcrumbs: [
      { link: '/admin', name: 'Administração' },
      { name: 'Payloads' },
    ]
  },
  path: 'payloads',
}